module.exports = __webpack_public_path__ + "img/2.5f55c34f.png";